<template>
  <vs-popup :active.sync="isActive" id="discount">
    <div class="discount-popup-inner">
      <vs-row vs-type="flex" vs-w="12" class="p-0 m-0">
        <vs-button
          color="transparent"
          class="payment-label bg-primary2 text-white w-full discount-header-title"
          icon-pack="feather"
          icon="icon-percent"
        >
          İndirim Seçenekleri
        </vs-button>
      </vs-row>

      <vs-row vs-type="flex" vs-w="12" class="info-row discount-meta-row" v-if="activePersonel">
        <vs-col vs-type="flex" class="w-auto discount-meta-name">
          <p class="text-primary bold mr-3">Personal Adı :</p>
          <p class="text-primary">{{ activePersonel.name }}</p>
        </vs-col>
        <vs-col vs-type="flex" class="w-auto ml-auto discount-meta-datetime">
          <p class="text-primary">{{ currentDate }}</p>
        </vs-col>
        <vs-col vs-type="flex" class="w-auto ml-3">
          <p class="text-primary">{{ currentTime }}</p>
        </vs-col>
      </vs-row>

      <div class="discount-popup-body">
        <div class="discount-panel-form">
          <div class="discount-scroll-form">
            <p class="discount-section-label">Ürün tutarı</p>
            <div class="discount-amount-cards">
              <div class="discount-amount-card half-friendly-border bg-secondary sale-box-shadow discount-old-title">
                <span class="text-dark bold">Ürün Tutarı</span>
                <span class="text-primary bold">{{ $toCurrency(priceToDiscount) }}</span>
              </div>
              <div
                v-if="enteredPrice > 0"
                class="discount-amount-card half-friendly-border bg-secondary sale-box-shadow discount-old-title"
              >
                <span class="text-dark bold">Yeni Ürün Tutarı</span>
                <span class="text-success bold">
                  {{ discountedTotalPreview.toFixed(2) }}
                  ₺
                </span>
              </div>
            </div>

            <p class="discount-section-label">İndirim tipi</p>
            <div class="discount-type-toggle">
              <vs-button
                @click="
                  discountType = 0;
                  enteredPriceStr = '';
                "
                color="transparent"
                class="friendly-border sale-box-shadow text-white bold bg-primary2 discount-type-btn"
                :class="{ 'bg-success': discountType == 0, 'pay-attention': discountType == null }"
              >
                Yüzde(%)
              </vs-button>
              <vs-button
                @click="
                  discountType = 1;
                  enteredPriceStr = '';
                "
                color="transparent"
                class="friendly-border sale-box-shadow text-white bold bg-primary2 discount-type-btn"
                :class="{ 'bg-success': discountType == 1, 'pay-attention': discountType == null }"
              >
                Tutar(₺)
              </vs-button>
            </div>

            <div class="discount-field-block">
              <p class="discount-section-label">İndirim sebebi</p>
              <input style="display: none" type="text" name="username" />
              <v-select
                type="select"
                class="w-full discount-reason-select"
                placeholder="İndirim Sebebi Giriniz."
                id="discountReason"
                v-model="selectedDiscountReason"
                disableBrowserAutocomplete
                :options="discountReasons"
                itemid="id"
                label="name"
                name="İndirim Sebebi"
                v-validate="'required|min:3'"
                push-tags
              />
              <span class="text-danger text-sm" v-show="errors.has('İndirim Sebebi')">{{
                errors.first("İndirim Sebebi")
              }}</span>
            </div>

            <div class="discount-field-block discount-field-textarea">
              <p class="discount-section-label">Açıklama</p>
              <vs-textarea v-validate="'required'" name="Açıklama" v-model="discountDescription" label="Açıklama" />
            </div>
          </div>
        </div>

        <div class="discount-panel-keypad">
          <p class="discount-section-label discount-keypad-label">Tuş takımı</p>
          <div class="calc-screen half-friendly-border discount-display-screen">
            <p
              class="bold calc-screen-entry-price discount-display-value"
              :class="{ 'text-dark': discountType != null }"
            >
              - {{ enteredPriceStr }} {{ discountType == 0 ? "%" : "₺" }}
            </p>
          </div>

          <vs-button
            color="transparent"
            :disabled="discountType == null"
            class="discount-clear-btn sale-box-shadow bg-secondary text-primary bold"
            @click="clearEnteredPrice"
          >
            Sil
          </vs-button>

          <div
            class="discount-quick-grid"
            :class="discountType == 0 ? 'discount-quick-grid--percent' : 'discount-quick-grid--amount'"
          >
            <button
              v-for="rate in quickRates"
              :key="rate.name"
              type="button"
              class="discount-quick-btn"
              :class="{ disabled: discountType == null }"
              @click="discountType != null ? applyQuickRate(rate) : null"
            >
              {{ rate.name }}
            </button>
          </div>

          <div class="discount-keypad-grid">
            <button
              v-for="number in numbers"
              :key="number"
              type="button"
              class="discount-key"
              :class="{ disabled: discountType == null }"
              @click="discountType != null ? appendNumber(number) : null"
            >
              {{ number }}
            </button>
            <button
              type="button"
              class="discount-key discount-key--zero"
              :class="{ disabled: discountType == null }"
              @click="discountType != null ? enterZero() : null"
            >
              0
            </button>
            <button
              type="button"
              class="discount-key discount-key--comma"
              :class="{ disabled: discountType == null }"
              @click="discountType != null ? enterComma() : null"
            >
              ,
            </button>
          </div>
        </div>
      </div>

      <div class="discount-popup-actions">
        <vs-button
          @click="getBack"
          size="large"
          icon="icon-arrow-left"
          icon-pack="feather"
          color="transparent"
          class="discount-action-btn discount-action-cancel half-friendly-border sale-box-shadow bg-secondary text-primary bold"
        >
          Vazgeç
        </vs-button>
        <vs-button
          size="large"
          color="transparent"
          @click="appendDiscount"
          :disabled="
            discountType == null ||
            enteredPrice == 0 ||
            selectedDiscountReason == null ||
            discountDescription == ''
          "
          class="discount-action-btn discount-action-apply half-friendly-border sale-box-shadow bg-success text-white bold"
        >
          Uygula
        </vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import { roundTry2 } from "@/utils/moneyTry";

export default {
  props: {
    priceToDiscount: {
      type: Number,
      required: true,
    },
    currentTime: {
      type: String,
      required: true,
    },
    currentDate: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedDiscountReason: null,
      discountDescription: "",
      isActive: false,
      discountType: 0,
      numbers: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
      percentRates: [
        { id: 1, name: "İkram", percent: 100 },
        { id: 2, name: "%25", percent: 25 },
        { id: 3, name: "%20", percent: 20 },
        { id: 4, name: "%15", percent: 15 },
        { id: 5, name: "%10", percent: 10 },
      ],
      amountRates: [
        { id: 1, name: "İkram", fraction: 1 },
        { id: 2, name: "1/2", fraction: 2 },
        { id: 3, name: "1/3", fraction: 3 },
        { id: 4, name: "1/4", fraction: 4 },
      ],
      enteredPrice: 0,
      enteredPriceStr: "",
    };
  },
  computed: {
    quickRates() {
      return this.discountType == 0 ? this.percentRates : this.amountRates;
    },
    activePersonel: function () {
      return this.$store.getters["selfservice/getActivePersonal"];
    },
    discountReasons() {
      return this.$store.getters["selfservice/getDiscountReasons"] || [];
    },
    /** İndirim sonrası tutar — POS/ödeme ile aynı roundTry2 kuralı */
    discountedTotalPreview() {
      if (this.enteredPrice <= 0) return 0;
      const origin = roundTry2(this.priceToDiscount);
      if (this.discountType == 1) {
        return roundTry2(origin - roundTry2(this.enteredPrice));
      }
      return roundTry2(origin - roundTry2((origin * this.enteredPrice) / 100));
    },
  },
  watch: {
    enteredPriceStr: function (newVal, oldVal) {
      if (newVal == "") {
        this.enteredPrice = 0;
        return;
      }
      let parsedPrice = parseFloat(newVal.replace(",", "."));
      if (this.discountType == 1) {
        if (parsedPrice > this.priceToDiscount) {
          this.enteredPriceStr = oldVal;
        } else {
          this.enteredPrice = parsedPrice;
        }
      } else if (this.discountType == 0) {
        if (parsedPrice > 100) {
          this.enteredPriceStr = oldVal;
        } else {
          this.enteredPrice = parsedPrice;
        }
      }
    },
    isActive(val) {
      if (!val) {
        this.initValues();
      }
    },
  },
  methods: {
    initValues() {
      this.selectedDiscountReason = null;
      this.discountDescription = "";
      this.discountType = 0;
      this.enteredPrice = 0;
      this.enteredPriceStr = "";
      this.$validator.reset();
      this.setSelectDefaultPaymentMethod();
    },
    appendDiscount() {
      if (this.$validator.validateAll()) {
        const origin = roundTry2(this.priceToDiscount);
        let discountAmount =
          this.discountType == 1
            ? roundTry2(this.enteredPrice)
            : roundTry2((origin * this.enteredPrice) / 100);
        const payedPriceAfter = roundTry2(origin - discountAmount);
        const discountObj = {
          originPrice: origin,
          priceToDiscount: discountAmount,
          payedPrice: payedPriceAfter,
          value: this.enteredPrice,
          description: this.selectedDiscountReason.name,
          unit: this.discountType == 1 ? "₺" : "%",
          discountDescription: this.discountDescription,
        };
        this.$emit("appendDiscount", discountObj);
        this.isActive = false;
      }
    },
    setSelectDefaultPaymentMethod() {
      this.$store.dispatch(
        "selfservice/setSelectedPaymentMethod",
        this.$store.getters["selfservice/getPaymentMethods"][0]
      );
    },
    getBack() {
      this.isActive = false;
    },
    applyQuickRate(rate) {
      if (this.discountType == 0) {
        this.enteredPriceStr = String(rate.percent);
      } else {
        const amount = roundTry2(this.priceToDiscount / rate.fraction);
        this.enteredPriceStr = amount.toFixed(2).replace(".", ",");
      }
    },
    clearLastChar: function () {
      this.enteredPriceStr = this.enteredPriceStr.substring(0, this.enteredPriceStr.length - 1);
    },
    appendNumber: function (str) {
      this.enterPriceData(str);
    },
    clearEnteredPrice: function () {
      this.enteredPriceStr = "";
    },
    enterComma: function () {
      this.enterPriceData(",");
    },
    enterZero: function () {
      this.enterPriceData("0");
    },
    enterPriceData: function (val) {
      if (this.enteredPriceStr.includes(",")) {
        let split = this.enteredPriceStr.split(",");
        if (split[1].length > 1) {
          return;
        }
      }
      if (val === ",") {
        if (!this.enteredPriceStr.includes(",")) {
          if (this.enteredPriceStr.length === 0) {
            this.enteredPriceStr = this.enteredPriceStr + "0" + val;
          } else {
            this.enteredPriceStr = this.enteredPriceStr + val;
          }
        }
      } else if (val === "0") {
        if (this.enteredPriceStr.length > 0) {
          this.enteredPriceStr = this.enteredPriceStr + val;
        } else {
          return;
        }
      } else {
        this.enteredPriceStr = this.enteredPriceStr + val;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      const root = document.getElementById("discount");
      if (!root) return;
      const cb = root.querySelector('[role="combobox"]');
      if (cb) cb.name = "discountReasonInput";
    });
  },
};
</script>

<style>
/* Vuesax .con-vs-popup varsayılan olarak align-items:center — indirim penceresini ekranın üstüne taşı */
.con-vs-popup:has(.discount-popup-inner),
#discount.con-vs-popup {
  align-items: flex-start !important;
  justify-content: center !important;
  padding-top: env(safe-area-inset-top, 0px);
  box-sizing: border-box;
}

#discount .vs-popup .vs-popup--header {
  display: none;
}

#discount .vs-popup .vs-popup--content {
  padding: 0 !important;
  margin: 0 !important;
  width: 100%;
  max-height: min(94vh, 900px) !important;
  overflow: hidden !important;
  display: flex !important;
  flex-direction: column !important;
  box-sizing: border-box;
}

#discount .vs-popup {
  border-radius: 1.25rem !important;
  width: min(100vw, 1000px) !important;
  max-width: 100vw !important;
  max-height: min(96vh, 920px) !important;
  box-sizing: border-box;
  margin-top: 0 !important;
}

.discount-popup-inner {
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-height: min(92vh, 880px);
  overflow: hidden;
  background: linear-gradient(180deg, #faf8f7 0%, #f3eeec 100%);
}

.discount-header-title.payment-label {
  font-size: clamp(0.95rem, 3.5vw, 1.2rem) !important;
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
  border-radius: 1.25rem 1.25rem 0 0 !important;
}

.discount-meta-row.info-row {
  padding: 0.55rem 0.75rem !important;
  font-size: clamp(0.75rem, 2.8vw, 1rem) !important;
  background: rgba(255, 255, 255, 0.92) !important;
  border-top: 1px solid rgba(90, 52, 50, 0.08);
  flex-wrap: wrap;
}

.discount-popup-body {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  flex: 1 1 auto;
  min-height: 0;
  gap: 0.85rem;
  padding: 0.75rem 0.85rem 0.5rem;
  box-sizing: border-box;
}

.discount-panel-form {
  flex: 1 1 58%;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.discount-scroll-form {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-right: 0.15rem;
}

.discount-section-label {
  margin: 0 0 0.35rem;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(90, 52, 50, 0.55);
}

.discount-amount-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.85rem;
}

.discount-amount-card {
  flex: 1 1 calc(50% - 0.35rem);
  min-width: 8.5rem;
  justify-content: center;
  text-align: center;
  display: grid;
  gap: 0.25rem;
  padding: 0.65rem 0.5rem;
  border-radius: 12px;
  border: 1px solid rgba(90, 52, 50, 0.08);
}

.discount-type-toggle {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  margin-bottom: 0.85rem;
}

.discount-type-btn {
  flex: 1 1 50%;
  min-height: 2.65rem !important;
}

.discount-field-block {
  margin-bottom: 0.75rem;
}

.discount-field-textarea .vs-textarea,
.discount-field-textarea textarea {
  width: 100%;
}

.discount-field-textarea textarea {
  min-height: 5.5rem;
  font-size: 0.9rem !important;
  border-radius: 10px !important;
}

.discount-reason-select {
  width: 100%;
}

.discount-panel-keypad {
  flex: 0 0 38%;
  max-width: 22rem;
  min-width: 11.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  min-height: 0;
}

.discount-keypad-label {
  margin-bottom: 0.15rem;
}

.discount-display-screen {
  width: 100%;
  padding: 0.55rem 0.75rem !important;
  border-radius: 12px;
  background: #fff !important;
  border: 1px solid rgba(90, 52, 50, 0.1);
  box-sizing: border-box;
}

.discount-display-value {
  margin: 0;
  text-align: right;
  font-size: clamp(1rem, 4vw, 1.35rem) !important;
  line-height: 1.2;
}

.discount-clear-btn {
  width: 100% !important;
  margin: 0 !important;
  min-height: 2.35rem !important;
  border-radius: 10px !important;
  font-size: 0.82rem !important;
}

.discount-quick-grid {
  display: grid;
  gap: 0.4rem;
  margin-bottom: 0.35rem;
}

.discount-quick-grid--percent {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.discount-quick-grid--amount {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.discount-quick-btn {
  min-height: 2.5rem;
  border: 1px solid rgba(90, 52, 50, 0.14);
  border-radius: 12px;
  background: linear-gradient(180deg, #fff 0%, #f4efed 100%);
  color: #4a2c2a;
  font-weight: 700;
  font-size: clamp(0.75rem, 3vw, 0.9rem);
  cursor: pointer;
  font-family: inherit;
  box-shadow: 0 2px 6px rgba(62, 38, 36, 0.06);
  padding: 0.35rem 0.25rem;
}

.discount-quick-btn:active:not(.disabled) {
  filter: brightness(0.97);
}

.discount-quick-btn.disabled,
.discount-key.disabled {
  opacity: 0.45;
  pointer-events: none;
  cursor: not-allowed;
}

.discount-keypad-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.4rem;
  width: 100%;
  margin-top: 0.15rem;
}

.discount-key {
  min-height: 2.65rem;
  border: 1px solid rgba(90, 52, 50, 0.14);
  border-radius: 12px;
  background: linear-gradient(180deg, #fff 0%, #f4efed 100%);
  color: #4a2c2a;
  font-weight: 700;
  font-size: clamp(0.95rem, 4vw, 1.15rem);
  cursor: pointer;
  font-family: inherit;
  box-shadow: 0 2px 6px rgba(62, 38, 36, 0.06);
  padding: 0.35rem;
}

.discount-key:active:not(.disabled) {
  filter: brightness(0.97);
}

.discount-key--zero {
  grid-column: span 2;
}

.discount-key--comma {
  grid-column: span 1;
}

.discount-popup-actions {
  display: flex;
  flex-direction: row;
  gap: 0.55rem;
  padding: 0.65rem 0.75rem calc(0.65rem + env(safe-area-inset-bottom, 0px));
  flex-shrink: 0;
  border-top: 1px solid rgba(90, 52, 50, 0.1);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, #f0eae8 100%);
  box-shadow: 0 -6px 18px rgba(62, 38, 36, 0.06);
}

.discount-action-btn {
  flex: 1 1 50%;
  min-width: 0 !important;
  min-height: 2.85rem !important;
  border-radius: 12px !important;
}

.discount-action-btn .vs-button--text {
  font-size: clamp(0.82rem, 3.2vw, 1rem) !important;
  font-weight: 700 !important;
}

.discount-old-title {
  justify-content: center;
  text-align: center;
  display: grid;
  padding: 10px 0 10px 0;
}

.pay-attention {
  -webkit-animation: glowing 1500ms infinite;
  -moz-animation: glowing 1500ms infinite;
  -o-animation: glowing 1500ms infinite;
  animation: glowing 1500ms infinite;
}

@-webkit-keyframes glowing {
  0% {
    background-color: rgb(21, 178, 0);
    -webkit-box-shadow: 0 0 3px rgb(21, 178, 0);
  }
  50% {
    background-color: rgb(0, 255, 34);
    -webkit-box-shadow: 0 0 40px rgb(0, 255, 34);
  }
  100% {
    background-color: rgb(21, 178, 0);
    -webkit-box-shadow: 0 0 3px rgb(21, 178, 0);
  }
}

@-moz-keyframes glowing {
  0% {
    background-color: rgb(21, 178, 0);
    -moz-box-shadow: 0 0 3px rgb(21, 178, 0);
  }
  50% {
    background-color: rgb(0, 255, 34);
    -moz-box-shadow: 0 0 40px rgb(0, 255, 34);
  }
  100% {
    background-color: rgb(21, 178, 0);
    -moz-box-shadow: 0 0 3px rgb(21, 178, 0);
  }
}

@-o-keyframes glowing {
  0% {
    background-color: rgb(21, 178, 0);
    box-shadow: 0 0 3px rgb(21, 178, 0);
  }
  50% {
    background-color: rgb(0, 255, 34);
    box-shadow: 0 0 40px rgb(0, 255, 34);
  }
  100% {
    background-color: rgb(21, 178, 0);
    box-shadow: 0 0 3px rgb(21, 178, 0);
  }
}

@keyframes glowing {
  0% {
    background-color: rgb(21, 178, 0);
    box-shadow: 0 0 3px rgb(21, 178, 0);
  }
  50% {
    background-color: rgb(0, 255, 34);
    box-shadow: 0 0 40px rgb(0, 255, 34);
  }
  100% {
    background-color: rgb(21, 178, 0);
    box-shadow: 0 0 3px rgb(21, 178, 0);
  }
}

.vs__dropdown-menu {
  max-height: 19vh !important;
  overflow-x: hidden !important;
  overflow-y: scroll !important;
}

@media (max-width: 767px) {
  #discount .vs-popup {
    width: 100% !important;
    max-width: 100vw !important;
    border-radius: 1rem 1rem 0 0 !important;
  }

  #discount .vs-popup .vs-popup--content {
    max-height: 100dvh !important;
  }

  .discount-popup-inner {
    max-height: 100dvh;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  .discount-popup-body {
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    padding: 0.55rem 0.65rem 0.35rem;
    gap: 0.65rem;
  }

  .discount-panel-form {
    flex: 1 1 auto;
    min-height: 0;
    width: 100%;
    max-width: 100%;
  }

  .discount-panel-keypad {
    flex: 0 0 auto;
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }

  .discount-keypad-grid {
    gap: 0.45rem;
  }

  .discount-key {
    min-height: 2.85rem;
  }

  .discount-meta-row .vs-col {
    flex-wrap: wrap;
  }

  .discount-popup-actions {
    position: sticky;
    bottom: 0;
    z-index: 3;
    padding-top: 0.55rem;
  }
}

@media (min-width: 768px) {
  .discount-popup-actions {
    position: relative;
  }
}
</style>
